import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Acknowledged At", -1)
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Expires On", -1)
const _hoisted_5 = { class: "form-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Number", -1)
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Self Insured Policy Provider", -1)

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["self_insured"],
  setup(__props, { emit }) {



const formFields = ref({
  self_insured_policy_acknowledged_at: "",
  self_insured_policy_expires_on: "",
  self_insured_policy_number: "",
  self_insured_policy_provider: "",
});

watch(formFields.value, () => {
  emit("self_insured", formFields.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.self_insured_policy_acknowledged_at) = $event)),
        type: "date"
      }, null, 512), [
        [_vModelText, formFields.value.self_insured_policy_acknowledged_at]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.self_insured_policy_expires_on) = $event)),
        type: "date"
      }, null, 512), [
        [_vModelText, formFields.value.self_insured_policy_expires_on]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.self_insured_policy_number) = $event)),
        type: "text"
      }, null, 512), [
        [_vModelText, formFields.value.self_insured_policy_number]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.self_insured_policy_provider) = $event)),
        type: "text"
      }, null, 512), [
        [_vModelText, formFields.value.self_insured_policy_provider]
      ])
    ])
  ], 64))
}
}

})